import React from "react";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";

function Pendente() {
  return (
    <AppLayout>
      <div className="verify-container">
        <h2>⏳ Pagamento pendente</h2>
        <p>Estamos aguardando a confirmação do seu pagamento. Você será notificado em breve.</p>
      </div>
      <Footer />
    </AppLayout>
  );
}

export default Pendente;
